import { render, staticRenderFns } from "./TreeNodeDialog.vue?vue&type=template&id=01b3f275&scoped=true"
import script from "./TreeNodeDialog.vue?vue&type=script&lang=js"
export * from "./TreeNodeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b3f275",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/cyimu/Desktop/shiliang/vgo/VGO_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01b3f275')) {
      api.createRecord('01b3f275', component.options)
    } else {
      api.reload('01b3f275', component.options)
    }
    module.hot.accept("./TreeNodeDialog.vue?vue&type=template&id=01b3f275&scoped=true", function () {
      api.rerender('01b3f275', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGenerator/index/TreeNodeDialog.vue"
export default component.exports